import { gsap } from "gsap";
const personModal = document.getElementById( "person-modal" );
const closePersonModal = document.getElementById( "close-person-modal" );

if ( personModal && closePersonModal ) {
  closePersonModal.addEventListener( "click", () => {
    personModal.style.display = "none";
    gsap.to( personModal.querySelector( "img" ), {
      translateY: 25,
      duration: 0,
    } );
  } );

  window.onclick = ( event ) => {
    if ( event.target === personModal ) {
      personModal.style.display = "none";
      gsap.to( personModal.querySelector( "img" ), {
        translateY: 25,
        duration: 0,
      } );
    }
  };
}
const teamListingSections = document.querySelectorAll( "section.team-listing" );
teamListingSections.forEach( ( section, i ) => {
  section.querySelectorAll( ".slide" ).forEach( ( slide, i ) => {
    slide.addEventListener( "click", () => {
      personModal.querySelector( "img" ).src = slide.querySelector( "img" ).src;
      personModal.querySelector( "h2" ).innerHTML =
        slide.querySelector( "h3" ).innerHTML;
      personModal.querySelector( "h4" ).innerHTML =
        slide.querySelector( "h5" ).innerHTML;
      personModal.querySelector( "div.richtext" ).innerHTML =
        slide.querySelector( "div.bio" ).innerHTML;
      personModal.querySelector( "h2" ).innerHTML =
        slide.querySelector( "h3" ).innerHTML.replace( /<br\s*\/?>/gi, " " );
      personModal.style.display = "flex";
      gsap.to( personModal.querySelector( "img" ), {
        translateY: 0,
        duration: 0.5,
        ease: "power2.inOut",
      } );

      // Scroll to top of the container within the fixed div
      const container = personModal.querySelector( ".container" );
      if ( container ) {
        container.scrollTop = 0;
      }
    } );
  } );
  const slider = tns( {
    autoplay: false,
    controls: true,
    nav: false,
    loop: false,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector( ".slider-controls" ),
    speed: 500,
    gutter: 24,
    fixedWidth: 281,
    responsive: {
      768: {
        items: 1,
        gutter: 24,
      },
    },
  } );
} );
